import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import React, { useEffect, useState } from "react";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { Button, Stack, TextField } from "@mui/material";
import { ChannelkartNetworkGet } from '../../services/networkService';
import DefaultHeading from '../../components/heading/DefaultHeading';
import { useLocation } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';

const JobsConfigurationAllResult = () => {

    const [startDate, setStartDate] = useState<Dayjs | null>(dayjs().subtract(1, 'day'));

    const [endDate, setEndDate] = useState<Dayjs | null>(dayjs());
    const [allResult, setAllResult] = useState<Record<string, any>[]>([]);

    let data: Record<string, any>[] = [];

    const formatDateTime = (date: Dayjs | null): string => {
        return date ? date.format("YYYY-MM-DD HH:mm:ss") : "";
    };
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    };
    const query = useQuery();
    const jobName = query.get('jobName');

    const handleStartDateChange = (newDate: Dayjs | null) => {
        setStartDate(newDate);
        setEndDate(null);
    };

    const getData = async () => {
        try {
            const url = `/v1/query/jobtaskresults?jobName=${jobName}&size=1000&fromDate=${formatDateTime(startDate)}&toDate=${formatDateTime(endDate)}`
            const response = await ChannelkartNetworkGet(url);
            response?.data?.features.map((key: Record<string, any>) => {
                const attributesObject = JSON.parse(key.attributes);
                const values = {
                    id: key.id,
                    status: key.status,
                    type: key.type,
                    jobName: attributesObject.jobName,
                    time: key.creation_time,
                }
                const newData = [...data, values];
                data = newData;
            });
            setAllResult(data);
        } catch (error) {
            console.error(error);
        }
    }

    const columnsHeader = [
        { field: 'jobName', headerName: 'Job Name', width: 600 },
        { field: 'type', headerName: 'Task ID', width: 225 },
        { field: 'time', headerName: 'Time', width: 225 },
        {
            field: 'status',
            headerName: 'Status',
            width: 175,
            renderCell: (params: any) => {
                const value = params.value as 'SUCCESS' | 'FAILURE';
                const backgroundColor = value === 'SUCCESS' ? '#eff8f7' : '#fddee3';
                const color = value === 'SUCCESS' ? '#31c2b1' : '#d84c5a';
                return (
                    <div style={{ backgroundColor, color, padding: 5, textAlign: 'center', borderRadius: 5, }}>
                        {value}
                    </div>
                );
            },
        },
    ];


    useEffect(() => { getData() }, []);

    return (<div className="all-result-container">
        <DefaultHeading heading='Schedular Report' />
        <Stack spacing={2.8} direction={"row"} className="date-pickers">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    label="From Date"
                    inputFormat="DD-MM-YYYY"
                    value={startDate}
                    onChange={handleStartDateChange}
                    renderInput={(props) => (
                        <TextField {...props} disabled size="small" />
                    )}
                />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    label="To Date"
                    inputFormat="DD-MM-YYYY"
                    value={endDate}
                    onChange={(value) => {
                        if (value) {
                            setEndDate(value);
                        }
                    }}
                    minDate={startDate || dayjs()}
                    disabled={!startDate}
                    renderInput={(props) => (
                        <TextField {...props} disabled size="small" />
                    )}
                />
            </LocalizationProvider>
            <Button variant="contained" onClick={() => getData()}>Apply</Button>
        </Stack>
        <div className="all-result-table" style={{ height: 395, width: '100%' }}>
            <DataGrid rows={allResult} columns={columnsHeader} />
        </div>
    </div>
    );
};

export default JobsConfigurationAllResult